// components/Tabs.js
import { Tab } from '@headlessui/react'
import { Fragment } from 'react'
import { ClockIcon, StarIcon, TagIcon } from '@heroicons/react/outline'
import { classNames } from '../helpers/utils'
import BlogTags from './BlogTags'
import BlogSectionRelatedPosts from './BlogSectionRelatedPosts'
import BlogSectionPopularPosts from './BlogSectionPopularPosts'

const tabs = [
    { name: 'Clock', icon: ClockIcon, Content: BlogSectionRelatedPosts },
    { name: 'Star', icon: StarIcon, Content: BlogSectionPopularPosts },
    { name: 'Tag', icon: TagIcon, Content: BlogTags },
]

export default function BlogTabs({
    tags,
    latestBlogPosts,
    initialCategories,
    initialTotalPages,
    popularPosts,
}) {
    return (
        <Tab.Group>
            <Tab.List className="flex p-1 space-x-1">
                {tabs.map((tab, index) => (
                    <Tab as={Fragment} key={index}>
                        {({ selected }) => (
                            <button
                                className={classNames(
                                    'w-full py-2.5 text-sm leading-5 font-medium text-gray-700',
                                    'focus:outline-none border-b-2  ',
                                    selected
                                        ? ' border-olm'
                                        : 'text-gray-400 hover:text-gray-700 border-gray-300',
                                )}>
                                <tab.icon className="h-5 w-5 mx-auto" />
                            </button>
                        )}
                    </Tab>
                ))}
            </Tab.List>
            <Tab.Panels className="mt-2">
                {tabs.map((TabItem, index) => (
                    <Tab.Panel
                        key={index}
                        className={classNames(
                            'focus:outline-none focus:ring-2 ring-offset-2 ring-offset-blue-400 ring-white ring-opacity-60',
                        )}>
                        <p>
                            <TabItem.Content
                                tags={tags}
                                initialPage={1}
                                initialPosts={latestBlogPosts}
                                initialCategories={initialCategories}
                                initialTotalPages={initialTotalPages}
                                isBlog={true}
                                shouldShowFeaturedPost={false}
                                popularPosts={popularPosts}
                            />
                        </p>
                    </Tab.Panel>
                ))}
            </Tab.Panels>
        </Tab.Group>
    )
}
